import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

function InvitationRedirect() {
  const params = useParams();

  return (
    <Navigate to={`/register?invitationId=${params.invitationId}`} replace />
  );
}

export default InvitationRedirect;
